import { isPostHogConfigured, posthog } from '@lib/posthog';

/**
 * PostHog's native pageview event name. Funnels, paths, entry pages and web
 * analytics all read `$pageview` without configuration; a custom event name
 * would forfeit every one of them.
 */
export const PAGEVIEW_EVENT_NAME = '$pageview';

/**
 * FFH-2370 — capture a pageview keyed on the route pattern.
 *
 * `routePattern` is the Next.js route (`router.pathname`), e.g.
 * `/player/[slug]`, not the raw URL — so high-cardinality routes group under
 * one property value instead of shattering into thousands. The raw URL still
 * arrives on every event as `$current_url`, stamped by the SDK at capture
 * time, so nothing is lost.
 *
 * This is deliberately NOT in the `AnalyticsEvents` registry: `$pageview` is
 * a PostHog-native event, not a product event from the tracking plan, and its
 * only sanctioned call site is `PostHogPageviewTracker`.
 *
 * Consent gating is PostHog's own: capture is opted out until
 * `setPostHogConsent(true)`, so a call made without consent sends nothing.
 */
export const capturePageview = (routePattern: string): void => {
  if (typeof window === 'undefined') return;
  if (!isPostHogConfigured()) return;

  posthog.capture(PAGEVIEW_EVENT_NAME, { route: routePattern });
};
